import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Toaster } from '@8x8/oxygen-toaster';

import { TABLET_THRESHOLD, MOBILE_THRESHOLD } from '../core/constants';
import AuthPane from './auth-pane';
import { isSignUp as getIsSignUp, isVpaaS, setDocumentTitle } from '../services/auth0';
import { getAdvertisement, getAdvertisementVpaaS } from '../services/rotating-ads';
import { isMobile, isIOSSafari } from '../core/utils';
import analytics from '../services/amplitude';
import withTheme from './with-theme';
import { Flex } from '~/components/basic/containers';
import UnsupportedPage from '~/components/unsupported-page';

const MainContainer = styled(Flex)`
  justify-content: space-around;
  background: ${props => props.background};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  ${ ({ theme }) => isMobile() ? `${theme.sansSerif}` : `${theme.nunitoFont}`};

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    background: none;
  }
  white-space: pre-line;
`;

const RotatingContentContainer = styled.div`
  display: flex;
  margin: auto 20px auto auto;
  width: 700px;
  @media screen and (max-width: ${TABLET_THRESHOLD}px) {
    display: none;
  }
`;

const CenteredContainer = styled.div`
  display: flex;

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    width: 100%;
  }
`;

const MainPage = () => {
  const getAd = () => isVpaaS() ? getAdvertisementVpaaS() : getAdvertisement();

  const [isSignUp, setIsSignUp] = useState(getIsSignUp());
  const [advertise, setAdvertise] = useState(getAd());

  useEffect(() => {
    analytics.trackPageView(analytics.PAGE_NAMES.LOGIN_SIGNUP_PAGE);
  }, []);

  const onSwitchMode = () => {
    const signUp = getIsSignUp();

    analytics.trackPageView(analytics.PAGE_NAMES.LOGIN_SIGNUP_PAGE);
    setIsSignUp(signUp);
    setDocumentTitle(signUp);
    setAdvertise(getAd());
  }

  const getRotatingContent = () => {
    if (typeof advertise.template === 'string') {
      return (
        <RotatingContentContainer dangerouslySetInnerHTML={{ __html: advertise.template }} />
      )
    }
    return (
      <RotatingContentContainer >
        <advertise.template />
      </RotatingContentContainer>
    );
  }

  if (isSignUp && isIOSSafari() && !isVpaaS()) {
    return <UnsupportedPage />;
  }

  return (
    <MainContainer fullWidth fullHeight background={advertise.background}>
      <Toaster />
      <CenteredContainer>
        {getRotatingContent()}
        <AuthPane isSignUp={isSignUp} onSwitchMode={onSwitchMode} />
      </CenteredContainer>
    </MainContainer>
  );
}

export default withTheme(MainPage);